import React from "react";

const SiemensUseCaseGraph = () => {
  return (
    <div className="subscribe_area">
     
       <div className="col-lg-12 case-study-details">
              <div className="section_main_title mb-3">
                <h3>The Difference It Made</h3>
              
              </div>
             
            <img
              src="assets/images/siemens-use-case-graph.webp" 
              alt="proplus data approach" 
              className="mx-auto w-32"
            /> 
         
         
        </div>
    </div>
  );
};

export default SiemensUseCaseGraph;
